import { Layers } from "appworks/graphics/layers/layers";
import { Services } from "appworks/services/services";
import { State } from "appworks/state-machine/states/state";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { PartnerConnectManager } from "partner-connect/partner-connect-manager";

import moment = require("moment");

export class PartnerConnectHistoryPopupState extends State {

    public onEnter() {
        uiFlags.set(UIFlag.IDLE, false);
        uiFlags.set(UIFlag.REPLAY, false);

        const layer = Layers.get("History");

        if (layer && layer.hasScene("replay")) {
            layer.setScene("replay").execute();

            layer.getText("bet_value").text = Services.currency.format(PartnerConnectManager.historyData.bet);
            layer.getText("time_value").text = moment(PartnerConnectManager.historyData.timestamp).format("hh:mm:ss YYYY.MM.DD");
            layer.getText("session_value").text = PartnerConnectManager.historyData.wagerid;

            if (PartnerConnectManager.historyData.win) {
                layer.getText("win_value").text = Services.currency.format(PartnerConnectManager.historyData.win);
            } else {
                layer.getText("win_value").text = "";
                layer.getText("win_lbl").text = "";
            }
            if (PartnerConnectManager.historyData.startBalance) {
                layer.getText("initial_value").text = Services.currency.format(PartnerConnectManager.historyData.startBalance);
            } else {
                layer.getText("initial_value").text = "";
                layer.getText("initial_lbl").text = "";
            }
            if (PartnerConnectManager.historyData.endBalance) {
                layer.getText("final_value").text = Services.currency.format(PartnerConnectManager.historyData.endBalance);
                Services.transaction.setBalance(PartnerConnectManager.historyData.endBalance);
            } else {
                layer.getText("final_value").text = "";
                layer.getText("final_lbl").text = "";
            }
        }
    }
}
